import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import TeamMessageReply from "./teamMessageReply";
import {
  MainSuiteSection,
  TicketingSuiteSection,
  BloggingSuiteSection,
  StorageSuiteSection,
  AdvertsSuiteSection,
  SaasCrmSuiteSection,
  AnalyticsSuiteSection,
  EcommerceSuiteSection,
  FinanceSuiteSection,
  IndustrialSuiteSection,
  AiStudioSuiteSection,
  DevopsSuiteSection,
  SubscriptionPlgSuiteSection,
  HrPeopleSuiteSection,
  LogisticsSuiteSection,
  HealthcareSuiteSection,
  EducationSuiteSection,
  RealEstateSuiteSection,
  SecuritySuiteSection
} from "./suites/suiteSections";

export default function Dashboards() {
  return (
    <div className="dashboard-wrapper">
      <Routes>
        <Route index element={<Navigate to="main" replace />} />
        <Route path="main/*" element={<MainSuiteSection />} />
        <Route path="team-message/:contactId" element={<TeamMessageReply />} />
        <Route path="ticketing/*" element={<TicketingSuiteSection />} />
        <Route path="blogging/*" element={<BloggingSuiteSection />} />
        <Route path="storage/*" element={<StorageSuiteSection />} />
        <Route path="adverts/*" element={<AdvertsSuiteSection />} />
        <Route path="saas-crm/*" element={<SaasCrmSuiteSection />} />
        <Route path="analytics/*" element={<AnalyticsSuiteSection />} />
        <Route path="ecommerce/*" element={<EcommerceSuiteSection />} />
        <Route path="finance/*" element={<FinanceSuiteSection />} />
        <Route path="industrial/*" element={<IndustrialSuiteSection />} />
        <Route path="ai-studio/*" element={<AiStudioSuiteSection />} />
        <Route path="devops/*" element={<DevopsSuiteSection />} />
        <Route
          path="subscription-plg/*"
          element={<SubscriptionPlgSuiteSection />}
        />
        <Route path="hr-people/*" element={<HrPeopleSuiteSection />} />
        <Route path="logistics/*" element={<LogisticsSuiteSection />} />
        <Route path="healthcare/*" element={<HealthcareSuiteSection />} />
        <Route path="education/*" element={<EducationSuiteSection />} />
        <Route path="real-estate/*" element={<RealEstateSuiteSection />} />
        <Route path="security/*" element={<SecuritySuiteSection />} />
        <Route path="*" element={<Navigate to="/error" replace />} />
      </Routes>
    </div>
  );
}
